import { AuthActionTypes, IAuthState } from './types';
import {
  SET_CUSTOM_LOGIN_DATA,
  RESET_CUSTOM_LOGIN_DATA_SUCCESS,
} from './actions';

const initialState: IAuthState = {
  accessToken: null,
  refreshToken: null,
};

export const authReducer = (state = initialState, action: AuthActionTypes) => {
  switch (action.type) {
    case SET_CUSTOM_LOGIN_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CUSTOM_LOGIN_DATA_SUCCESS:
      return initialState;
    default:
      return state;
  }
};
